<template>
    <div class="register-term-page">
        <top-bar class="topbar"></top-bar>

        <div class="term-page">
            <div class="chanel-head">
                <div class="head1">ลงทะเบียนกับชาเนล เพื่อรับข่าวสารจากแบรนด์</div>
                <div>คำชี้แจงการเก็บรักษาข้อมูลส่วนบุคคล</div>
                <!-- <div> ข้อมูลอีเว้นท์ ผลิตภัณฑ์ขนาดทดลอง และบริการต่างๆ</div> -->
            </div>
            <div class="term-wrapper">
                <div class="detail-term">
                    <div>
                        ท่านยินยอมด้วยตัวท่านเองและในนามของบุคคลอื่นใดผู้ซึ่งมีข้อมูลส่วนบุคคลที่ท่านได้ให้ไว้แก่ชาเนลและบริษัทแม่และบริษัทในเครือ (“ชาเนล”) โดยใช้ข้อมูลส่วนบุคคลที่ท่านได้ให้ไว้ (“ข้อมูลส่วนตัว”) เพื่อวัตถุประสงค์ในการควบคุมการขายและการเก็บบันทึก เพื่อนำประสบการณ์ของท่านมาใช้กับชาเนล บนพื้นฐานของคุณสมบัติส่วนบุคคลของท่าน วันสำคัญของท่านและข้อมูลส่วนบุคคลอื่น ๆ บริหารการส่งมอบและส่งคืนผลิตภัณฑ์ ให้บริการลูกค้าและการตอบข้อซักถามและข้อร้องเรียนของท่าน เพื่อวัตถุประสงค์ในการวิจัยและพัฒนาผลิตภัณฑ์ เพื่อวัตถุประสงค์ทางการตลาดทางตรงตามความยินยอมของท่าน ซึ่งเกี่ยวข้องกับแฟชั่นและเครื่องประดับ นาฬิกาและเครื่องเพชรพลอย(ไฟน์จิวเวลรี่) และผลิตภัณฑ์น้ำหอมและความงามของชาเนล ตามที่ท่านยินยอม ท่านตกลงว่าข้อมูลส่วนบุคคลอาจแบ่งปัน เปิดเผย หรือถ่ายทอดไปสู่กลุ่มบริษัทชาเนลทั่วโลก และไปสู่ตัวแทนและผู้ให้บริการทางการบริหาร การตลาด และการวิจัยเพื่อวัตถุประสงค์ดังกล่าว ชาเนลจะปฏิบัติตามคำร้องขอของท่านที่จะไม่ใช้ข้อมูลส่วนบุคคลเพื่อวัตถุประสงค์ทางการตลาดที่กล่าวไว้ข้างต้น หากท่านประสงค์ที่จะร้องขอดังกล่าว กรุณาติดต่อเจ้าหน้าที่บริการลูกค้า ท่านยินยอมที่จะถ่ายโอนข้อมูลส่วนบุคคลไปยังสถานที่นอกประเทศไทย เพื่อดำเนินการตามวัตถุประสงค์ หรือวัตถุประสงค์ที่เกี่ยวข้องโดยตรง ตามที่กำหนดไว้ในคำชี้แจงนี้ ท่านมีสิทธิร้องขอให้เข้าถึง แก้ไข หรือลบข้อมูลส่วนบุคคล หากท่านประสงค์ให้ชื่อของท่านถูกลบออกจากรายชื่อผู้ติดต่อและรายชื่อผู้รับไปรษณีย์ของเรา หรือประสงค์สอบถามข้อมูลส่วนบุคคล (รวมถึงการเข้าถึงและการแก้ไข) กรุณาติดต่อเจ้าหน้าที่บริการลูกค้า, Chanel Customer Care, 34th floor, The Offices at Central World Building, No. 999/9, Rama I Road, Pathumwan District, Bangkok 10330, Thailand. (ที่อยู่ทางอีเมล์ contact-th@chanel.com)
                    </div>
                </div>
                <div class="blur-text"></div>
            </div>
            <div class="accept-wrapper">
                <div class="icon" @click="clickAcceptAge()">
                    <img v-show="isAcceptAge" src="@/assets/img/radio_active.png">
                    <img v-show="!isAcceptAge" src="@/assets/img/radio_unactive.png">
                </div>
                <div class="text">
                    ข้าพเจ้ายืนยันว่ามีอายุอย่างน้อย 20 ปีขึ้นไป
                </div>

            </div>
            <div class="accept-wrapper">
                <div class="icon" @click="clickAcceptTerm()">
                    <img v-show="isAccept" src="@/assets/img/radio_active.png">
                    <img v-show="!isAccept" src="@/assets/img/radio_unactive.png">
                </div>
                <div class="text">
                  ข้าพเจ้าประสงค์รับการสื่อสารการตลาดทางตรงตามที่กำหนดไว้ในคำชี้แจงด้านการเก็บข้อมูลส่วนบุคคลข้างต้น ผ่านทางอีเมล โทรศัพท์ สื่อสังคมออนไลน์ ข้อความสั้น ข้อความโต้ตอบแบบทันที ไปรษณีย์ และวิธีอื่นใดที่ข้าพเจ้าอาจให้ความยินยอมเป็นครั้งคราว
                </div>
                <div class="btn-accept-term">
                    <button class="btn btn-primary btn-custom-dark"
                        :class="{'disable-btn': !isAccept || !isAcceptAge}" @click="requestOtp()"> ตกลง </button>
                </div>
            </div>

        </div>

        <b-modal
            :id="modalAlert.id"
            modal-class="modal-alert alert-term-modal"
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc
        >
            <div class="modal-alert-wrapper">
                <div class="modal-base-wrapper">
                    <div class="modal-base alert-body">
                        <div class="modal-base-head"></div>
                        <div class="modal-base-body">
                            <div class="text-error">
                                <p>
                                    กรุณากดยืนยันคำชี้แจ้งการเก็บรักษาข้อมูลส่วนบุคคล
                                </p>
                                <button
                                    class="btn btn-primary btn-custom-dark"
                                    @click="clickOkModalAlert();">
                                    ตกลง
                                </button>
                            </div>
                        </div>
                        <div class="modal-base-footer"></div>
                    </div>
                </div>
            </div>
        </b-modal>

    </div>
</template>
<script>

import TopBar from "@/components/TopBar.vue";
import { TrackingService } from "@/helper/TrackingHelper.js";

export default {
name: "TermComponent",
    props: {
        view: String,
        busModalTerm: Object
    },
    components: {
        TopBar,
    },
    data: function() {
        return {

            isAccept: false,
            isAcceptAge: false,
            registerdata: "",
            modalAlert: {
                id: "modal-term-alert-",
                title: "ss",
                strBtnOk: "",
                message: "",
                tag: ""
            },
            modalConfirm: {
                id: "modal-term-confirm-",
                title: "",
                strBtnOk: "",
                strBtnCancel: "",
                message: "",
                tag: "",
                isChecked: false,
                triggerConsentModal: true
            },

            tracking: new TrackingService(this),
        };
    },
    created: function() {



        this.modalAlert.id += this.view;
        this.modalConfirm.id += this.view;
    },
    mounted: function() {
        this.busModalTerm.$on('setPhoneNumber', this.setPhoneNumber);
        this.busModalTerm.$on("showAlertModal", this.showModalAlert);
        this.busModalTerm.$on("hideAlertModal", this.hideModalAlert);

        this.busModalTerm.$on("showConfirmModal", this.showModalConfirm);
        this.busModalTerm.$on("hideConfirmModal", this.hideModalConfirm);



    },
    methods: {
        setPhoneNumber: function (config) {
            this.registerdata = config;

            this.$nextTick(() => {

			    window.scrollTo(0, 0);
		    });

        },
        requestOtp: function () {

            this.tracking.event("regis_consent", "click_next_to_otp");
            if (!this.isAccept) {
                this.showModalAlert();
                return;
            }

            var objRegisterconfig = {
                // display_contac_number: this.displayContactNumber,
                registerdata: this.registerdata,
                tag: 'register_otp',
            }

            this.$emit('onClicknext', objRegisterconfig);
        },

        clickAcceptAge: function () {
            this.isAcceptAge = !this.isAcceptAge;
        },

        clickAcceptTerm: function () {

            this.tracking.event("regis_consent", "click_agree_conset");
            this.isAccept = !this.isAccept;
        },

        showModalConfirm: function() {
            this.modalConfirm.title = "";
            this.modalConfirm.message = "";
            this.modalConfirm.strBtnOk = "ถัดไป";
            this.modalConfirm.strBtnCancel = "Cancel";
            this.modalConfirm.tag = "";

            this.$bvModal.show(this.modalConfirm.id);
        },

        showModalAlert: function() {
            this.modalAlert.title = "";
            this.modalAlert.message = "";
            this.modalAlert.strBtnOk = "Ok";
            this.modalAlert.tag = "";
            this.$bvModal.show(this.modalAlert.id);
        },
        clickOkModalAlert: function() {

            this.tracking.event("regis_consent", "click_popup_confirm_consent");
            this.$bvModal.hide(this.modalAlert.id);
        },
    }

}
</script>
<style lang="scss" scoped>

    @import "ModalAlert.scss";
    @import "TermComponent.scss";
</style>
